export const MESSAGE = {
  SUCCESS: 'upd/MESSAGE_SUCCESS',
  ERROR: 'upd/MESSAGE_ERROR',
};

export const success = payload => ({
  type: MESSAGE.SUCCESS,
  payload,
});

export const error = payload => ({
  type: MESSAGE.ERROR,
  payload,
});
